import { render } from "./educationPage.vue?vue&type=template&id=b6cb20c8"
import script from "./educationPage.vue?vue&type=script&lang=js"
export * from "./educationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__